const dictionary = {
  copyright: "Tüm Hakları Saklıdır.",
  cancel: "Vazgeç",
  submit: "Gönder",
  reject: "Reddet",
  accept: "Kabul Et",
  "update-contact-info": "Buradan iletişim bilgilerinizi güncelleyin.",
  logout: "Çıkış Yap",
  profile: "Profil",
  delegation: "İş Ortaklığı",
  agree: "Onaylıyorum",
  users: "Kullanıcılar",
  "user-cases": "İlanlar",
  "connection-error":
    "Bağlantı sorunu oluştu, lütfen daha sonra tekrar deneyiniz.",
  search: "Ara",
  edit: "Güncelle",
  delete: "Kaldır",
  user: "Vatandaş",
  lawyer: "Vekil",
  admin: "Yönetici (Admin)",
  agent: "Moderatör",
  premium: "Premium",
  "create-date": "Oluşturulma Tarihi",
  selected: "Seçildi",
  approve: "Onayla",
  confirm: "Onayla",
  abort: "İptal",
  error: "İşleminiz gerçekleştirilemedi, lütfen daha sonra tekrar deneyiniz.",
  success: "İşleminiz gerçekleştirilmiştir.",
  "rows-per-page": "Liste Aralığı",
  active: "Yayında",
  deactive: "Durdurulmuş",
  pending: "Onay Bekliyor",
  rejected: "Reddedilmiş",
  on_hold: "Askıya Alınmış",
  completed: "Tamamlanmış",
  homepage: "Anasayfa",
  save: "Kaydet",
  update_contact_info:
    "Lütfen devam etmeden önce iletişim bilgilerinizi güncelleyiniz.",
  review: "İncele",
  "my-cases": "İlanlarım",
  "my-offers": "Tekliflerim",
  "incoming-offers": "Aldığınız Teklifler",
  "has-no-offer": "Henüz bir teklfiniz bulunmuyor.",
  "contact-us": "Bize Ulaşın",
  "privacy-policy": "Gizlilik Sözleşmesi",
  faq: "SSS",
  "how-to": "Nasıl Yapılır",
  "app-require-online":
    "Bu uygulamayı kullanabilmek için internet bağlantısı gereklidir.",

  // Login
  login: "Giriş",
  register: "Kayıt Ol",
  forgotPassword: "Şifremi Unuttum",
  email: "E-Posta",
  "email-required": "E-Posta alanı zorunludur.",
  "email-pattern":
    "Hatalı e-posta biçimi, lütfen geçerli bir e-posta adresi girin.",
  password: "Şifre",
  "password-required": "Şifre alanı zorunludur",
  changePassword: "Şifre Güncelle",
  googleLogin: "Google ile Giriş",
  googleRegister: "Google ile Kayıt Ol",
  signInWithApple: "Apple ile Giriş",
  fpSuccess:
    "Şifre güncelleme bağlantısı e-posta adresinize gönderildi, lütfen gelen kutunuzu kontrol edin.",
  fpError:
    "Şifre güncelleme isteğinizi işleme alırken bir sorun oluştu, lütfen daha sonra tekrar deneyin.",
  enterCaptcha: "Lütfen doğrulama kodunu giriniz.",
  captchaError: "Lütfen güvenlik doğrulamasını tamamlayınız.",
  captchaFetchError:
    "Doğrulama kodunu alırken bir hata oluştu, lütfen daha sonra tekrar deneyiniz.",
  loginError: "Hatalı e-posta veya şifre girdiniz.",
  userExists:
    "Bu e-posta ile daha önce oluşturulmuş bir hesap bulunuyor, dilerseniz şifremi unuttum adımlarını izleyebilirsiniz.",
  userBlocked: "Hesabınız engellenmiştir.",
  enterVerificationCode: "Lütfen e-posta adresinize gönderilen kodu giriniz:",
  verificationFailed: "Doğrulama hatası.",
  registerSuccess:
    "Hesabınız oluşturulmuştur, uygulamaya giriş yapabilirsiniz.",
  userAgreementAccept: "Üyelik sözleşmesini okudum, anladım ve onaylıyorum",
  userNotExists:
    "Bu e-posta ile oluşturulmuş bir hesap bulunmamaktadır, lütfen önce kayıt olunuz.",
  userAlreadyExists:
    "Bu e-posta ile oluşturulmuş bir hesap zaten bulunuyor, lütfen giriş yapınız.",
  invalidCaptcha: "Geçersiz doğrulama kodu, lütfen tekrar deneyiniz.",
  invalidEmail: "Geçersiz e-posta adresi, lütfen tekrar deneyiniz.",

  // Forgot Password
  "reset-password": "Şifre Sıfırlama",
  "new-password": "Yeni şifrenizi giriniz:",
  "new-password-validate": "Yeni şifrenizi tekrar giriniz:",
  "invalid-hash": "Geçersiz kod",
  "new-password-not-valid":
    "Lütfen en az 6 en fazla 50 haneli bir şifre giriniz.",
  "new-password-not-comply":
    "Şifreler birbiriyle uyuşmuyor, lütfen doğrulama amacıyla şifrenizi tekrar yazınız.",
  "reset-successful":
    "Şifreniz başarıyla yenilenmiştir, giriş sayfasına giderek giriş yapabilirsiniz.",

  // Homepage
  "search-post": "İlan ara...",
  "new-case": "Yeni İlan",
  "new-delegation": "Yeni İş Ortaklığı",
  "open-cases": "Yayındaki İlanlarınız",
  budget: "Bütçe",
  "greet-lawyer":
    'Henüz bir iş ortaklığınız bulunmuyor, hemen oluşturmak için <a href="/delegation/new">buraya tıklayın</a>',
  "greet-user":
    'Merhaba {0}! Henüz bir ilanınız bulunmuyor, hemen oluşturmak için <a href="/case/new">buraya tıklayın</a>',
  "are-you-lawyer":
    'Avukat mısınız? <a href="/profile">Buradan profil sayfasına giderek başvurunuzu yapabilirsiniz.</a>',
  "most-used-case-categories": "En sık kullanılan kategoriler",
  "most-offered-cases": "En çok teklif alan ilanlar",
  "most-hand-shake-cases": "Anlaşma sağlanan ilanlar",
  "see-more-cases": "{0} daha ilanınız bulunuyor, görmek için tıklayınız.",
  "your-offers": "Teklifleriniz",
  "your-cases": "İlanlarınız",
  "your-partnerships": "İş Ortaklıklarınız",

  // Profile
  "your-profile": "Profil Bilgileriniz",
  "user-id": "Kullanıcı No",
  "first-name": "İsim",
  "last-name": "Soyisim",
  "profile-email-pattern": "Lütfen geçerli bir e-posta adresi giriniz.",
  "profile-email-required": "E-posta bilgisi zorunludur.",
  "phone-number": "Telefon Numarası",
  "profile-phone-pattern": "Lütfen geçerli bir telefon numarası giriniz.",
  "profile-phone-required": "Telefon numarası bilgisi zorunludur.",
  "profile-first-name-pattern": "Lütfen geçerli bir isim giriniz.",
  "profile-first-name-required": "İsim bilgisi zorunludur.",
  "profile-first-name-maxLength": "İsim bilgisi çok uzun olmamalıdır.",
  "profile-last-name-pattern": "Lütfen geçerli bir soyisim giriniz.",
  "profile-last-name-required": "Soyisim bilgisi çok uzun olmamalıdır.",
  "user-saved": "Bilgileriniz kaydedilmiştir.",
  "user-save-failed":
    "Bilgileriniz kaydedilirken bir sorun oluştu lütfen tekrar deneyiniz.",
  "lawyer-registration-info":
    "Baro kaydınız varsa bu alanlara giriş yapabilirsiniz",
  "lawyer-bar-info": "Onaylı baro bilgileriniz:",
  "lawyer-pending-info": "Başvurunuz onay aşamasındadır.",
  "bar-no": "Baro Numarası",
  "bar-no-minLength": "Baro numarası 5 haneli olmalıdır.",
  "bar-no-maxLength": "Baro numarası 5 haneli olmalıdır.",
  "bar-no-validate": "Baro numarasıyla baro ismi birlikte girilmelidir.",
  "bar-name": "Baro İsmi",
  "bar-name-minLength": "Baro ismi en az 10 harf olmalıdır.",
  "bar-name-maxLength": "Baro ismi en fazla 100 karakter olmalıdır.",
  "bar-name-validate": "Baro numarasıyla baro ismi birlikte girilmelidir.",
  "bar-name-pattern": "Baro ismi sadece harflerden oluşmalıdır",
  "profile-roles-validate":
    "Vekil rolü için baro no ve baro ismi girilmelidir.",
  "enter-code": "Kodu buraya giriniz",
  "send-code": "Kod Gönder",
  "validate-code": "Kodu Doğrula",
  "wrong-code": "Hatalı kod!",
  "lawyer-sign-up": "Başvuru Yap",
  "id-photos": "Kimlik fotoğrafları (Arka ve Ön)",
  "id-photos-rules":
    "Lütfen baro kimliğinizin ön ve arka yüzlerini 'jpg' formatında yükleyiniz, dosya boyutu {0} kb'dan fazla olmamalıdır.",
  "id-photos-size-error": "Dosya boyutu {0} kb'dan fazla olmamalıdır",
  "id-photos-missing":
    "Lütfen vekil başvurusu için kimliğinizin arka ve ön yüzü olmak üzere iki adet fotoğraf seçiniz.",
  "lawyer-application": "Avukatlık Başvurusu",
  "select-file": "Dosya Seç",
  "doc-save-failed":
    "Doküman yükleme başarısız oldu, lütfen daha sonra tekrar deneyiniz.",
  "lawyer-application-success":
    "Avukatlık başvurunuz gerçekleştirildi, lütfen onaylanmasını bekleyiniz.",
  "lawyer-application-legal-warning":
    "<b>Değerli Üyemiz;</b> <br/><br/> Buradan kaydınızı yaptırarak sisteme vekil olarak eklenmenizi talep edebilirsiniz. İş bu başvuru ile tarafımıza Türkiye Barolar Birliğine bağlı bir avukat olduğunuza ilişkin bildirimde bulunmuş olacaksınız. Başvurunuz ile birlikte tarafınızdan kimlik bilgileriniz de göndermeniz talep edilecektir. Tüm şart ve onayları sağlamanız durumunda web sitesi içerisinde yer alan ve şuan vatandaş statüsünde bulunan profiliniz Vekil olarak güncellenecektir. İş bu hususta vekil olduğunuza ilişkin olarak vermiş olduğunuz tüm bilgilerin doğruluğuna ilişkin tüm cezai ve hukuki sorumluluk tarafınıza ait olma niteliği taşımaktadır. <br/><br/> Başvurunuzu tamamlamanız ile birlikte bu hususu peşinen kabul ve beyan etmiş bulunmakta olduğunuzu tarafınıza hatırlatmak isteriz.",
  lawyerAgreementAccept: "Yukarıdaki yüküm ve sorumlulukları kabul ediyorum.",
  "deactivate-user": "Hesabı Kaldır",
  "deactivate-user-info": `
    Hesabınızı kaldırdığınız takdirde bütün ilanlarınız durdurulacak ve teklifleriniz kapatılacaktır, 
    diğer kullanıcılar ilan ve tekliflerinizi artık hiçbir şekilde görüntüleyemeyecektir.
    Hesabınıza bağlı e-posta adresinizle giriş yapmak istediğinizde tekrar kayıt olmanız gerekecektir.
    <br/><br/>
    Hesabınızı kaldırmak istediğinize emin misiniz?
  `,
  "user-deactivated": "Hesabınız kaldırılmıştır.",
  "user-deactivate-failed":
    "Hesap kaldırma işlemi başarısız oldu, lütfen daha sonra tekrar deneyiniz.",

  // Notifications
  notifications: "Bildirimler",
  new_offer_title: "Yeni bir teklifiniz var",
  new_offer_description: "{0} nolu ilanınız için bir teklif aldınız.",
  "mark-as-read": "Okundu olarak işaretle",
  offer_accepted_title: "Teklifiniz kabul edilmiştir",
  offer_accepted_description:
    "{0} nolu ilana verdiğiniz teklif ilan sahibi tarafından kabul edilmiştir. İlan sayfasını ziyaret ederek tekliflerim kısmından ilan sahibinin iletişim bilgilerine ulaşabilirsiniz.",
  offer_published_title: "Teklifiniz iletilmiştir.",
  offer_published_description:
    "{0} nolu ilana verdiğiniz teklif ilan sahibine iletilmiştir.",
  offer_rejected_title: "Teklifiniz reddedilmiştir",
  offer_rejected_description:
    "{0} nolu ilana verdiğiniz teklif reddedilmiştir, detayları tekliflerim sayfasından inceleyebilirsiniz.",
  case_approved_title: "İlanınız onaylandı",
  case_approved_description:
    "{0} nolu ilanınız yayınlanmıştır, sistemimize kayıtlı vekiller ilanınızı görüp teklif verebilirler.",
  case_rejected_title: "İlanınız reddedildi",
  case_rejected_description:
    "İlanınız {0} nolu reddedilmiştir. Reddetme nedenini profilinizden inceleyebilirsiniz.",
  lawyer_application_approved_title: "Vekil başvurunuz onaylandı",
  lawyer_application_approved_description:
    "Tebrikler, artık ilanları görebilir ve teklif verebilirsiniz.",
  lawyer_application_rejected_title: "Vekil başvrunuz reddedildi",
  lawyer_application_rejected_description:
    "Üzgünüz ancak vekil olabilmeniz için belirtilen şartları sağlamanız gerekiyor: {2}",

  // Cases
  "pending-cases": "Onay Bekleyenler",
  "rejected-cases": "Reddedilenler",
  "inactive-cases": "Yayında Olmayanlar",
  "on-hold-cases": "Beklemede Olanlar",
  "more-case-with-premium":
    "Hesabınızın ilan açma limiti {0} ilandır, premium hesaba geçerek daha fazla ilan verebilirsiniz.",
  "your-case-limit": "Toplam {0} ilan oluşturma hakkınız bulunmaktadır.",

  // CaseItem Details
  case: "İlan",
  "case-code": "İlan Kodu",
  "missing-case-id-in-url":
    "İlan bilgisine ulaşılamadı, adresteki ilan numarası eksik.",
  "case-category-selection": "Konu",
  "please-select-main-category": "Lütfen bir hizmet türü seçiniz",
  "please-select-sub-category": "Lütfen bir hizmet konusu seçiniz",
  "main-category-info": `
    Değerli kullanıcımız; Kanunlarımıza göre AVUKATLAR tüm hukuki konularda dava takibi yapabilmektedir. Ancak avukatların seçim hakları bulunmaktadır. Ayrıca günümüzde avukatların uzmanlaşma içinde oldukları ve belirli konulara daha fazla yatkınlık gösterdiği gözlemlenmektedir. Bu sebeple dava konunuzu doğru seçmeniz talep ettiğiniz hukuki yardım konusunda uzmanlaşmış ya da uzmanlaşmak isteyen avukatlara daha kolay ve hızlı ulaşmanızı sağlayacaktır.
Konuların daha kolay seçilmesi için tüm konuları Ceza, Hukuk ve Diğer işler şeklinde 3 ana kola bu kolları da kendi içlerinde çeşitli alt ve esas kollara ayırmış bulunuyoruz.
Lütfen tercihlerinizi dikkatlice yapınız. 
Tercihleriniz uzman denetleyici arkadaşlarımız tarafından denetlenerek doğrulanacaktır. Denetim neticesinde hatalı, eksik ya da kabul edilemeyecek ilanlar ya düzeltilerek yayınlanacak ya da yayından kaldırılacaktır.
  `,
  back: "Geri",
  next: "İleri",
  "case-city-selection": "Lokasyon",
  "please-select-case-city": "Dava ili",
  "please-select-user-city": "Yaşadığınız il",
  "case-description": "Açıklama",
  "please-enter-short-desc":
    "Lütfen çözümlenmesini istediğiniz sorununuz hakkında kısa bir açıklama giriniz.",
  "please-enter-long-desc": "Detaylı bilgi vermek ister misiniz?",
  "please-write-here": "Buraya yazınız...",
  "please-write-category": "Aradığınız konu başlığını yazınız...",
  summary: "Özet",
  "please-review-case-details": "Girdiğiniz Bilgiler",
  "case-type": "Ana Dava Kolu",
  "case-sub-type": "Alt Dava Kolu",
  "case-city": "Dava Şehri (Adliye)",
  "user-city": "Davacı Şehri",
  "case-short-desc": "Kısa Açıklama",
  "case-long-desc": "Detaylı Açıklama",
  "upgrade-to-premium": "Şimdi Premium'a Yükseltin",
  "short-desc-required":
    "Lütfen en az 50 karakterlik bir kısa açıklama giriniz.",
  "short-desc-minLength":
    "Yazmaya devam edin ve en az 50 karaktere tamamlayın.",
  "short-desc-maxLength": "En fazla 500 karakter girebilirsiniz.",
  "budget-required": "Lütfen bir fiyat giriniz.",
  "budget-min": "Girdiğiniz rakam en az 100 olmalıdır.",
  "give-offer": "Teklif Ver",
  "lawyer-offer-text":
    "Müvekkil adayınız için en az '50' karakterlik bir açıklama giriniz...",
  "min-offer-price-error": "Girebileceğiniz en düşük miktar: {0}",
  "empty-offer-description-error": "Lütfen kısa bir açıklama metni yazınız.",
  "lawyer-description-legal-warning-header":
    "Lütfen aşağıdaki metni okuyup onaylayınız:",
  "lawyer-description-legal-warning": `Değerli vekil kullanıcımız; Teklifinizin açıklama kısmında kısaca kendinizden bahsederek teklifinizi daha nitelikli hale getirebilirsiniz. Uyuşmazlığa ilişkin hukuki açıklama ve yönlendirme içeren açıklamalarınız ile “Vekilet Üyelik Sözleşmesi” ve kanunlara aykırı açıklamalar içeren teklifleriniz kabul edilmeyecektir. Teklifinize ilişkin gönder butonuna tıklayarak teklifinizi iletebilirsiniz. Teklifinizi göndermek ile teklifinizin açıklama kısmı içerisinde yer alan içeriğin “Vekilet Üyelik Sözleşmesi” ve kanunlara aykırı olması durumunda tüm cezai ve hukuki sorumluluğunun bizzat tarafınıza ait olduğunu kabul etmiş sayılacağınızı bildirmek isteriz.`,
  "type-more-with-premium":
    "Daha fazla karakter kullanmak için premium hesaba geçebilirsiniz",
  "max-char-reached": "Karakter üst limitine ulaştınız.",
  "more-offers-with-premium":
    "{0}/{1} teklif hakkınızı kullandınız, premium hesap ile sınırsız sayıda teklif verebilirsiniz!",
  "see-offers": "Teklifleri Gör ({0})",
  "contact-choice": "İletişim Tercihi",
  contact: "İletişim",
  "case-saved":
    "İlan talebiniz alınmıştır, gerekli kontroller yapıldıktan sonra yayına alınacaktır.",
  "please-select-one-contact-choice": "Lütfen en az bir seçim yapınız",
  EMAIL: "E-Posta",
  PHONE: "Telefon",
  IN_PERSON: "Yüz yüze",
  "change-short-desc": "Açıklamayı burdan düzenleyebilirsiniz:",
  "low-budget": "Düşük (₺)",
  "mid-budget": "Orta (₺₺)",
  "high-budget": "Yüksek (₺₺₺)",
  "unset-budget": "Belirtmek istemiyorum",
  kvkk: `
    İş bu ilan ve metninin;<br/><br/>
    •	Tarafımca üyelik başvurusu yapılırken bizzat yine tarafımca onaylanan “Vekilet Üyelik Sözleşmesi” ve ilgili tüm kanun ve mevzuata uygun olduğunu,<br/><br/>
    •	İlan kapsamı ile verilen ve tarafıma ait bilgilerin site içerisinde onayım ile yayınlanacak olan ilan ile paylaşılmasına rızam olduğunu,<br/><br/>
    •	ilan içerisinde yer alan her türlü içeriğin tüm cezai ve hukuki sorumluluğunun bizzat tarafıma ait olduğunu,<br/><br/>
    •	İş bu web sitesi yayın haklarının sahibinin tarımca bizzat yazılarak hazırlanan ilan metni sebebiyle hiçbir sorumluluğunun bulunmadığını<br/><br/>
    İş bu metni onaylamak suretiyle Kabul beyan ve taahhüt ederim.
  `,
  "description-info": `Değerli kullanıcımız; Bu kısımda hukuki uyuşmazlığınızı tanımlayabilecek özet bilgiler vermenizi, kesinlikle paylaşılması suç oluşturabilecek ya da ileride bu şekilde beyan etmeniz neticesinde hukuk mücadelenizi kötü bir şekilde etkileyecek bilgiler paylaşmamanızı önemle rica ederiz.
Lütfen açıklamalarınızı dikkatlice, anlaşılır bir dille ve hukuki uyuşmazlığınıza ilişkin kısa bir bilgi verecek şekilde yazınız. 
<br/><br/>
Örnek olarak 
“2019 yılı Mayıs ayı içerisinde kiralamış olduğum taşınmazımda oturan kiracı kira bedellerini 6 aydır ödemiyor. Bu konuda uzman bir avukattan destek almak istiyorum.”
<br/><br/>
Şeklinde açık ve sade bir şekilde yazabilirsiniz. Detayları sizlerle iletişime geçen avukatlar ile görüşebilirsiniz.
Tercihleriniz uzman denetleyici arkadaşlarımız tarafından denetlenerek doğrulanacaktır. Denetim neticesinde hatalı, eksik ya da kabul edilemeyecek ilanlar ya düzeltilerek yayınlanacak ya da yayından kaldırılacaktır.`,
  "budget-info": `Değerli kullanıcımız; Bu kısımda talep ettiğiniz hukuki desteğe ilişkin ayırabileceğiniz bütçeyi temsilen bir tercih yaparak aradığınız avukata daha hızlı ulaşmayı deneyebilirsiniz`,
  "contact-info":
    "Değerli kullanıcımız; Bu kısımda iletişim tercihlerinizi belirterek teklifini onayladığınız avukatların sizler ile hangi iletişim kanalları üzerinden ulaşmalarını istediğinizi bildirebilirsiniz",
  "deactivation-warning":
    "İlanınızı durdurduğunuzda ilanınıza verilmiş teklifleri kaybedeceksiniz, yine de devam etmek istiyor musunuz?",

  // Delegation Details
  city: "İl",
  district: "İlçe",
  "please-select-city": "Lütfen bir il seçiniz",
  "please-select-district": "Lütfen bir ilçe seçiniz",
  "please-enter-short-desc-lawyer":
    "Lütfen meslektaşlarınız için bir açıklama giriniz",
  delegationAgreement: `Değerli vekil kullanıcımız; "İş Ortaklığı İlanı" başvurusu ile birlikte tevkil yetkisine sahip olduğunuz işlerinizi diğer meslektaşlarımız ile birlikte yürütmek amacıyla ilan verebilir ve sizinle üstlenmiş olduğunuz işlerde iş birliği yapacak meslektaşlar bulabilirsiniz. İş birliği ilanlarına ilişkin olarak mesleki sorumluluk kaidelerini tarafınıza bir kez daha hatırlatarak vereceğiniz ilanların gerek Avukatlık Kanunu’ na gerekse de anayasa ile tüm kanun ve mevzuatlara uygun olma yükümlülüğü olduğunu, aykırılık durumunda tüm hukuki ve cezai sorumluluğun iş bu ilanın yayınlanması talebi ile gönderilmesi akabinde tarafınızda olduğunu kabul ve beyan ettiğinizi bildirmek isteriz.`,

  // CaseItem Search
  "no-search-result":
    "Arama kriterlerinize uygun sonuç bulunamamıştır, lütfen başka kelimelerle aramayı deneyiniz.",
  "order-by": "Sırala",
  "filter-by": "Filtrele",
  budgetAsc: "Bütçe ↑",
  budgetDesc: "Bütçe ↓",
  createDateAsc: "Oluşturulma Tarihi ↑",
  createDateDesc: "Oluşturulma Tarihi ↓",
  userProvinceAsc: "Yaşadığı Şehir ↑",
  userProvinceDesc: "Yaşadığı Şehir ↓",
  caseTypeAsc: "Dava Kolu ↑",
  caseTypeDesc: "Dava Kolu ↓",

  // Lawyer Summary
  "citizen-cases": "Vatandaş İlanları",
  "lawyer-cases": "İş Ortaklığı İlanları",
  "see-more-cases-lawyer": "Daha fazla ilan gör...",
  "lawyer-offer-info":
    "Lütfen müvekkiliniz için teklif ettiğiniz bir fiyat aralığı seçiniz",
  "open-offers": "Bekleyen teklifleriniz",
  "new-offer": "henüz yayınlanmamış teklifiniz var.",
  "approved-offers": "Onaylanmış teklifleriniz",
  "rejected-offers": "Reddedilen teklifleriniz",
  "on-hold-offers": "Askıya alınan teklifleriniz",
  "see-more-offers": "Diğer tekliflerinizi görmek için tıklayınız.",

  // OfferItem
  "offer-for-this-case": "Şu ilanınız için teklifi değerlendiriyorsunuz",
  "lawyer-message": "Vekilin mesajı",
  offers: "Teklifler",
  "no-offer-for-case": "Bu ilan için henüz bir teklif bulunmuyor",
  "phone-required-to-accept-offer":
    "Teklifleri kabul edebilmeniz için sisteme kayıtlı bir telefonunuz bulunmalıdır.",
  "you-rejected-offer": "Teklifi reddettiniz.",
  "offer-on-hold":
    "Başka bir teklifte anlaşma başlattığınız için bu teklif askıya alınmıştır.",
  "start-agreement": "Anlaşma Başlat",
  "started-agreement":
    "Bu teklif için bir anlaşma başlattınız, iletişim bilgileriniz vekil ile paylaşılmıştır. 2 hafta içinde anlaşmayı iptal edebilir ve diğer teklifleri değerlendirebilirsiniz, aksi takdirde ilanınız otomatik olarak sonlandırılacaktır.",
  "abort-agreement": "Anlaşmayı İptal Et",
  "bar-number": "Baro No",
  "no-client-action": "Müvekkil henüz herhangi bir teklifi değerlendirmedi.",
  "your-offer": "Teklifiniz",
  "your-offer-saved":
    "Teklifiniz kaydedilmiştir, onay verilmesi halinde müvekkile iletilecektir.",
  "your-offer-sent": "Teklifiniz iletilmiştir",
  "your-offer-rejected": "Teklifiniz reddedilmiştir",
  "client-on-hold-offer":
    "Müvekkil başka bir teklife anlaşma başlattığı için bu teklif askıya alınmıştır, anlaşmasını iptal etmesi halinde teklifiniz tekrar işleme alınacaktır.",
  "client-reject-offer": "Müvekkil teklifinizi reddetti.",
  "client-accepted-offer": "Müvekkil teklifinizi kabul etti",
  "client-preferred-contact": "Müvekkilin tercih ettiği iletişim bilgileri",
  "client-information": "Müvekkil bilgileri",
  "confirm-offer-approve":
    "Dikkat: Teklifi kabul ettikten sonra iletişim bilgileriniz teklif sahibiyle paylaşılacak ve 2 gün boyunca teklifi iptal edemeyeceksiniz, onaylıyor musunuz?",
  user_approved_other_offer: "İlan sahibi başka bir teklifi değerlendirdi.",

  // Admin
  documents: "Evraklar",
  "please-type-keyword": "Lütfen arama alanına giriş yapınız.",
  "no-result": "Herhangi bir sonuç bulunamadı.",
  "admin-panel": "Vekilet Yönetim Paneli",
  "approval-pending-cases": "Onay Bekleyen İlanlar",
  "approval-pending-offers": "Onay Bekleyen Teklifler",
  "select-cases-to-process": "İşlem yapmak istediğiniz ilanları seçebilirsiniz",
  "case-owner": "İlan Sahibi",
  "approve-selected-cases":
    "Bu ilanları onaylamak istediğinizden emin misiniz?",
  "approve-selected-offers":
    "Bu teklifleri onaylamak istediğinizden emin misiniz?",
  "reject-selected-cases":
    "Lütfen bir kaç kelimeyle neden reddetmek istediğinizi belirtiniz:",
  "reject-selected-offers":
    "Lütfen bir kaç kelimeyle neden reddetmek istediğinizi belirtiniz:",
  "reject-reason": "Reddetme nedeni",
  "reject-reason-minlength": "Lütfen en az 10 karakter giriniz.",
  "reject-reason-maxlength": "Lütfen 100 karakterden fazla giriş yapmayınız.",
  block: "Engelle",
  unblock: "Engeli Kaldır",
  activate: "Yayınla",
  deactivate: "Durdur",
  "activate-user": "Etkinleştir",
  "approval-pending-lawyers": "Onay Bekleyen Vekil Başvuruları",
  "user-roles": "Kullanıcı Rolleri",

  // Premium
  subscribePremiumNow: "ŞİMDİ PREMİUM'A YÜKSELTİN",
  premiumPageTitle: "Şimdi Premium'a Geç!",
  premiumPageSubtitle:
    "Değerli vekil kullanıcımız; cüzi bedeller ile ayrıcalıklı hesaba geçiş yaparak sayı sınırlaması olmadan daha fazla teklif verebilir ve tekliflerinizi daha çok vatandaşa ulaştırabilirsiniz.",
  creditCardInformation: "Kredi Kartı Bilgileri",
  cardHolderName: "Kart Sahibinin Adı ve Soyadı",
  cardNumber: "Kart Numarası",
  expirationMonth: "Ay",
  expirationYear: "Yıl",
  cvv: "Güvenlik Kodu (CVV)",
  "card-holder-required": "Bu alan zorunludur",
  "card-holder-minLength": "Lütfen en az 6 karakter giriniz.",
  "card-holder-maxLength": "En fazla 60 karakter girebilirsiniz",
  "card-holder-pattern": "Lütfen sadece harf giriniz",
  "card-number-required": "Bu alan zorunludur",
  "card-number-minLength": "Lütfen 16 haneli kart numaranızı eksiksiz giriniz.",
  "card-number-maxLength": "Kart numarası 16 haneli olmalıdır.",
  "card-number-pattern": "Lütfen sadece rakam giriniz",
  "expiration-month-required": "Bu alan zorunludur",
  "expiration-month-minLength": "Lütfen 2 haneli ay bilgisini giriniz.",
  "expiration-month-maxLength": "Ay bilgisi 2 haneli olmalıdır.",
  "expiration-month-pattern": "Lütfen sadece rakam giriniz.",
  "expiration-month-max": "Ay bilgisi en fazla 12 olabilir.",
  "expiration-month-min": "Ay bilgisi en az 01 olabilir.",
  "expiration-year-required": "Bu alan zorunludur",
  "expiration-year-minLength": "Lütfen 4 haneli yıl bilgisini giriniz.",
  "expiration-year-maxLength": "Yıl bilgisi 4 haneli olmalıdır.",
  "expiration-year-pattern": "Lütfen sadece rakam giriniz.",
  "cvv-required": "Bu alan zorunludur",
  "cvv-minLength":
    "Lütfen kartınızın arkasında bulunan 3 haneli cvv kodunu giriniz.",
  "cvv-maxLength": "CVV kodu 3 haneli olmalıdır.",
  "cvv-pattern": "Lütfen sadece rakam giriniz",
  "make-payment": "Ödeme Yap",

  // CaseItem Categories
  "c-1": "Ceza Davaları",
  "c-2": "Özel ve Kamu Hukuk Davaları",
  "c-3": "Diğer Takip ve Yabancı İşlemleri",
  "c-1-b-1": "Asliye Ceza Mahkemesi",
  "c-1-b-2": "Ağır ceza Mahkemesi",
  "c-1-b-3": "Savcılık Soruşturmaları",
  "c-2-b-1": "Aile",
  "c-2-b-2": "Ticaret",
  "c-2-b-3": "Sulh Hukuk",
  "c-2-b-4": "Kadastro",
  "c-2-b-5": "Tüketici",
  "c-2-b-6": "İş Mahkemeleri",
  "c-2-b-7": "Asliye Hukuk",
  "c-2-b-8": "Fikri Sınai",
  "c-2-b-9": "Diğer.",
  "c-2-b-10": "İdareye Karşı Davalar",
  "c-3-b-1": "Yabancı Vatandaş İşlemleri",
  "c-3-b-2": "Danışma",
  "c-3-b-3": "İcra",
  "c-1-b-1-s-1": "Hırsızlık Suçu",
  "c-1-b-1-s-2": "Cinsel Suçlar",
  "c-1-b-1-s-3": "Hakaret Suçu",
  "c-1-b-1-s-4": "Tehdit Suçu",
  "c-1-b-1-s-5": "Yaralama Suçu",
  "c-1-b-1-s-6": "Mala Zarar Verme Suçu",
  "c-1-b-1-s-7": "Dolandırıcılık Suçu",
  "c-1-b-1-s-8": "Güveni Kötüye Kullanma Suçu",
  "c-1-b-1-s-9": "Uyuşturucu Kullanma – Bulundurma Suçu",
  "c-1-b-1-s-10": "Sahtecilik Suçu",
  "c-1-b-1-s-11": "Bilişim Suçu",
  "c-1-b-1-s-12": "Diğer.",
  "c-1-b-2-s-1": "Uyuşturucu Ticareti Suçu",
  "c-1-b-2-s-2": "Örgütlü Suçlar",
  "c-1-b-2-s-3": "Sahtecilik",
  "c-1-b-2-s-4": "Cinsel Suçlar",
  "c-1-b-2-s-5": "Yağma (Gasp)",
  "c-1-b-2-s-6": "Kaçakçılık",
  "c-1-b-2-s-7": "Öldürme",
  "c-1-b-2-s-8": "Diğer.",
  "c-1-b-3-s-1": "Sanık Gözaltı Var",
  "c-1-b-3-s-2": "Sanık Gözaltı Yok",
  "c-1-b-3-s-3": "Şikâyet Başvurusu",
  "c-2-b-1-s-1": "Miras Davaları",
  "c-2-b-1-s-2": "Boşanma Davası",
  "c-2-b-1-s-3": "Vasi / Kayyım Atanması",
  "c-2-b-1-s-4": "Nafaka Davası",
  "c-2-b-1-s-5": "Velayet Davası",
  "c-2-b-1-s-6": "Uzaklaştırma vb. Tedbir Talepleri",
  "c-2-b-1-s-7": "Diğer.",
  "c-2-b-2-s-1": "Alacak Davaları",
  "c-2-b-2-s-2": "Diğer.",
  "c-2-b-3-s-1": "Kira Davaları",
  "c-2-b-3-s-2": "KMK (Site / Apartman Yönetim Davaları",
  "c-2-b-3-s-3": "Ortaklığın Giderilmesi (Ortak Mal Satış) Davaları",
  "c-2-b-3-s-4": "Diğer.",
  "c-2-b-4-s-1": "Kadastro Mahkemesi",
  "c-2-b-5-s-1": "Alacak",
  "c-2-b-5-s-2": "Tazminat",
  "c-2-b-5-s-3": "Hakem Heyeti Başvuru",
  "c-2-b-5-s-4": "Diğer.",
  "c-2-b-6-s-1": "İşçi Alacak",
  "c-2-b-6-s-2": "Tazminat",
  "c-2-b-6-s-3": "İşe İade",
  "c-2-b-6-s-4": "Diğer.",
  "c-2-b-7-s-1": "Taşınmaz Davaları",
  "c-2-b-7-s-2": "Alacak Davaları",
  "c-2-b-7-s-3": "Diğer.",
  "c-2-b-8-s-1": "Marka Patent Vb. Davaları",
  "c-2-b-9-s-1": "Diğer",
  "c-2-b-10-s-1": "İdare İşlem (Karar) iptal Davaları",
  "c-2-b-10-s-2": "İdare Tazminat Davaları",
  "c-2-b-10-s-3": "Diğer",
  "c-2-b-10-s-4": "Vergi Davaları",
  "c-3-b-1-s-1": "Vatandaşlık İşlemleri",
  "c-3-b-1-s-2": "İkamet İzin İşlemleri",
  "c-3-b-1-s-3": "Çalışma İzin İşlemleri",
  "c-3-b-1-s-4": "Deport İtiraz İşlemleri",
  "c-3-b-1-s-5": "Vize İşlemleri",
  "c-3-b-1-s-6": "Danışma İşlemleri",
  "c-3-b-1-s-7": "Diğer.",
  "c-3-b-2-s-1": "Sözlü (Görüşmeli) Danışma",
  "c-3-b-2-s-2": "Yazılı (Evrak Hazırlatmak Üzere) danışma",
  "c-3-b-2-s-3": "Arabuluculuk Vekil İşlemleri",
  "c-3-b-2-s-4": "Diğer.",
  "c-3-b-3-s-1": "Alacaklı Vekilliği",
  "c-3-b-3-s-2": "Borçlu Vekilliği",
  "c-3-b-3-s-3": "Diğer.",
};

export default dictionary;
